// Animation = require('./animation')
import A from './animation'
import S from './website'
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import {
  getToken
} from '@/utils/auth';
// import { WebSocket } from '@/views/svolt/project/history-data/websocket';

//获取动画对象
function getAnimation(params) {
  return new A.Animation(params);
}
//运行动画
function runAnimation(params) {
  let X = getAnimation(params);
  X.run();
}
//销毁动画
function destroyAnimation(params) {
  let X = getAnimation(params);
  X.destroy();
}
//繁星效果
export function runLogin(cls, width) {
  let container = document.getElementsByClassName(cls)[0];
  for (let i = 0; i < window.innerWidth / width; i++) {
    container.append(startFactory());
  }
}
//星工场
export function startFactory() {
  let star = document.createElement("div");
  let width = Math.ceil(Math.random() * 5);
  star.style.position = "absolute";
  star.style.width = width + 'px';
  star.style.height = width + 'px';
  star.style.backgroundColor = '#FFFFFF';
  star.style.top = Math.ceil(Math.random() * window.innerHeight) + 'px';
  star.style.left = Math.ceil(Math.random() * window.innerWidth) + 'px';
  star.style.boxShadow = "rgb(179 179 179) 0px 0px 1.5px 1.5px";

  star.style.borderRadius = width + 'px';

  // 当星星直径小于3时，有一个放大缩小的动画
  if (width < 4) {
    star.style.boxShadow = "#545454 0 0 " + width / 2 + "px " + width / 2 + "px";
    star.style.animation = "identifier 1000ms infinite 500ms";
  }
  return star;
}
//修改树结构属性
export function updateTreeData(treeData) {
  console.log(treeData);
  let iteration = function(arr) {
    let newArr = [];
    if (arr != undefined && arr.length > 0) {
      newArr = arr.map(item => {
        item.resourceId = item.resourceId + '.' + item.onlyId;
        if (item.disabled == true) {
          item.checked = 1;
        }
        if (item.children != undefined && item.children.length > 0) {
          iteration(item.children);
        }
        return item;
      });
    }
    return newArr;
  };
  let result = iteration(treeData);
  console.log(JSON.stringify(result), '111111111');
  return result;
}
//修改树结构属性
export function updateTreeDataV2(treeData) {
  // console.log(treeData);
  let iteration = function(arr) {
    let newArr = [];
    if (arr != undefined && arr.length > 0) {
      newArr = arr.map(item => {
        item.id = item.id + '.' + item.treeId;
        // if (item.disabled == true) {
        //   item.checked = 1;
        // }
        if (item.childrenList != undefined && item.childrenList.length > 0) {
          iteration(item.childrenList);
        }
        return item;
      });
    }
    return newArr;
  };
  let result = iteration(treeData);
  // console.log(JSON.stringify(result), 'V22222');
  return result;
}
//遍历所有节点
export function getAllNode(data, key) {
  let result = [];
  let indexs = [];
  key = key ? key : 'children';

  function getNode(data, fdata) {
    if (data instanceof Array) {
      data.forEach((item, index) => {
        if (item[key]) {
          getNode(item[key], item);
        }
        result.push(item);
      })
    }
  }
  getNode(data, data);
  return result;
}
//遍历所有节点
export function getAllNodeV2(data, key) {
  let result = [];
  key = key ? key : 'childrenList';

  function getNode(data, fdata) {
    if (data instanceof Array) {
      data.forEach((item, index) => {
        if (item[key]) {
          getNode(item[key], item);
        }
        result.push(item);
      })
    }
  }
  getNode(data, data);
  return result;
}

//添加记录菜单
export function addTab(obj) {
  let tab = sessionStorage.getItem('tab');
  if (!tab) {
    let first = JSON.stringify([{
      name: 'Home',
      title: '首页'
    }]);
    sessionStorage.setItem('tab', first);
    tab = first;
  }
  if (tab) {
    tab = JSON.parse(tab);
    let has = false;
    tab.forEach(item => {
      if (obj.name == item.name) {
        has = true;
      }
    })
    if (has == false) {
      tab.push(obj);
      sessionStorage.setItem('tab', JSON.stringify(tab));
    }
  }
  return tab;
}
//获取记录菜单
export function getTab() {
  return sessionStorage.getItem('tab');
}
//删除记录菜单
export function delTab(obj) {
  let tab = sessionStorage.getItem('tab');
  tab = JSON.parse(tab);
  let has = false;
  tab.forEach((item, index) => {
    if (obj.name == item.name) {
      has = index;
    }
  })
  if (has != false) {
    tab.splice(has, 1);
    sessionStorage.setItem('tab', JSON.stringify(tab));
  }
  return tab;
}
// 时间格式转换
export function formatDate(value, format) {
  let date = new Date()
  if (value) {
    date = new Date(value)
  }
  let y = date.getFullYear()
  if (isNaN(y)) {
    return value
  }
  let MM = date.getMonth() + 1
  MM = MM < 10 ? ('0' + MM) : MM
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let m = date.getMinutes()
  m = m < 10 ? ('0' + m) : m
  let s = date.getSeconds()
  s = s < 10 ? ('0' + s) : s
  let res = y + '/' + MM + '/' + d + ' ' + h + ':' + m + ':' + s
  if (format) {
    let fh = '/'
    if (format.indexOf('-') != -1) {
      fh = '-'
    }
    if (format.indexOf('/') != -1) {
      fh = '/'
    }
    if (format.length < 11) {
      res = y + fh + MM + fh + d
    }
    if (format.length > 11) {
      res = y + fh + MM + fh + d + ' ' + h + ':' + m + ':' + s
    }
  }
  return res
}
// 时间格式转换value值为妙
export function formatDateLine(value) {
  let date = new Date(value)
  // debugger
  let y = date.getFullYear()
  if (isNaN(y)) {
    return value
  }
  let MM = date.getMonth() + 1
  MM = MM < 10 ? ('0' + MM) : MM
  let d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  let h = date.getHours()
  h = h < 10 ? ('0' + h) : h
  let m = date.getMinutes()
  m = m < 10 ? ('0' + m) : m
  let s = date.getSeconds()
  s = s < 10 ? ('0' + s) : s
  return h + ':' + m + ':' + s
}
//获取数组内的选中的对象
/*
  val:需要对应的数据
  arr:需要检索的集合
  key:集合中对应的KEY,
  name:需要显示的字段
 */
export function getTypeOptions(val, arr, key, name) {
  let res = {};
  arr.forEach(item => {
    if (val == item[key]) {
      res = item;
    }
  })
  if (name) {
    res = res[name];
  }
  return res;
}
export function getHost() {
  return S.host.API_URL;
}
export function getActiveAuth() {
  let authJson = JSON.parse(localStorage.getItem(S.auth.ActiveAuth));
  let auth = [];
  authJson.forEach(item => {
    auth.push(item.resourceId);
  })
  return auth;
}
//过滤数据
export function myFilter(data) {
  if (data == null || data == undefined || data.length == 0) {
    return
  } else {
    for (let index = data.length - 1; index >= 0; index--) {
      // 删除状态2的元素,且不为过渡结点的元素
      if (data[index].resourceType != 4) {
        data.splice(index, 1)
      } else {
        let address = data[index].routingAddress;
        address = address.split('|');
        data[index].name = data[index].componentName;
        data[index].title = data[index].resourceNameShow;
        data[index].path = address[0];
        data[index].icon = data[index].icon;
        if (data[index].children.length == 0) {
          delete data[index].children
        }
      }
    }
  }
}
export function filterData(data) {
  // 到叶子节点了，返回,递归出口
  if (data == undefined || data == null || data.length == 0) {
    return
  } else {
    // 对每一层，遍历这个数组，调用filterData方法对每个元素下的数组进行同样的操作
    // 筛掉当前层的status为2的对象
    myFilter(data)
    for (let index in data) {
      filterData(data[index].children)
      if (data[index].children == 0) {
        delete data[index].children;
      }
    }

  }
}
//获取当前选中的节点
export function getSelectMenuNode(key, menuList) {
  let allNode = getAllNode(menuList);
  let node = {};
  allNode.forEach((item, index) => {
    if (item.name == key) {
      node = item;
    }
  });
  return node;
}
//获取menulist菜单
export function getMenuList() {
  let menu = JSON.parse(localStorage.getItem('ActiveMenu'));
  filterData(menu);
  let home = {
    name: 'Home',
    icon: 'el-icon-s-home',
    title: '首页',
    path: ''
  }
  let menuList = [home, ...menu];
  return menuList;
}
export function getArrByKey(data, k) {
  let key = k || 'value';
  let res = [];
  if (data) {
    data.forEach(function(t) {
      res.push(t[key]);
    });
  }
  return res;
};
export function getSymbolData(data) {
  let arr = [];
  for (var i = 0; i < data.length; i++) {
    arr.push({
      value: data[i].value,
      symbolPosition: 'end',
    });
  }
  return arr;
};
//链接websocket
export function connect() {
  let headers = {
    Authorization: getToken()
  };
  let url = S.host.WS_URL + '/svolt-ess-service/cloud-websocket?topic=emsdatav2&access_token=' + headers.Authorization;
  let socket = new WebSocket(url);
  let stp = Stomp.over(socket);
  return {
    _stomp: stp,
    _header: headers
  };
};
//断开链接
export function disConnect() {
  if (this.stompClient) {
    this.stompClient.disconnect();
  }
};
//处理链接websocket
export function initWebSocket(url, callback) {
  // function connect(){
  //   let headers = {
  //     Authorization:getToken()
  //   };
  //   let url = 'ws://svolt-ess-api-gateway-dev.svoltems.cn/svolt-ess-service/cloud-websocket?topic=emsdatav2&access_token='+headers.Authorization;
  //   let socket = new WebSocket(url);
  //   let stp = Stomp.over(socket);
  //   return {_stomp:stp,_header:headers};
  // }
  let obj = connect();
  this.stompClient = obj._stomp;
  let header = obj._header;
  //测试数据
  // url = '/topic/app/2-23304-190828-00004/CBa.BMS1.Summary.MaxSOH1';
  // console.log(url)
  this.stompClient.connect(
    header,
    () => {
      //订阅服务端提供的接口
      // console.log('进来了')
      this.stompClient.subscribe(url,
        msg => {
          let body = JSON.parse(msg.body);
          callback(body)
          // console.log('数据。。。',JSON.parse(msg.body));
        }, header
      );
    }, (err) => {
      console.log('失败', err);
      //重新连接
      initWebSocket(url, callback);
    });
};
class WebSocket_W {
  constructor(topic) {
    this.topic = topic;
  }
  stompClient = '';
  headers = {
    Authorization: getToken()
  };
  subscription = [];
  creat() {
    let url = S.host.WS_URL + '/svolt-ess-service/cloud-websocket?topic=' + this.topic + '&access_token=' + this
      .headers.Authorization;
    // console.log(url)
    this.socket = new WebSocket(url);
    this.socket.onclose = function(e) {
      logger.error('websocket 断开');
      logger.info(e.code + ' ' + e.reason + ' ' + e.wasClean);
    }

  };
  connect() {
    if (this.stompClient && (this.stompClient.connected || this.stompClient.connecting)) {
      return;
    }
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.connect(this.headers, () => {
      console.log('连接成功。。。');
      if (this.path && this.callback) {
        this.init(this.path, this.callback);
      }
    }, (err) => {
      console.log('失败', err);
      //重新连接
      setTimeout(() => {
        this.connect();
      }, 2000);
    })
  };
  init(url, callback) { //设备登录
    this.path = url;
    this.callback = callback;
    this.subscription = [];
    if (!this.stompClient || !this.stompClient.connected) {
      console.log('WebSocket未连接，等待连接成功后自动初始化');
      return;
    }
    for (let i = 0; i < url.length; i++) {
      let headers = {
        Authorization: getToken(),
        id: "mysubid" + i
      }
      var sub = this.stompClient.subscribe(url[i], msg => {
        let body = JSON.parse(msg.body);
        callback(body);
        // console.log('数据。。。', JSON.parse(msg.body));
      }, headers);
      this.subscription.push(sub);
    }
  };
  unsubscribe() {
    for (let i in this.subscription) {
      this.subscription[i].unsubscribe();
    }
    console.log("取消订阅！")
  };
  disConnect() {
    console.log("连接断开！")
    if (this.stompClient) {
      this.stompClient.disconnect();
    }
  };
};
/**
 * @description 格式化金额
 * @param number：要格式化的数字
 * @param decimals：保留几位小数 默认0位
 * @param decPoint：小数点符号 默认.
 * @param thousandsSep：千分位符号 默认为,
 */
export const formatMoney = (number, decimals = 0, decPoint = '.', thousandsSep = ',') => {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  let n = !isFinite(+number) ? 0 : +number
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  let toFixedFix = function(n, prec) {
    let k = Math.pow(10, prec)
    return '' + Math.ceil(n * k) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  let re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}
/* 数组去重 */
export function unique(arr) {
  return Array.from(new Set(arr));
}
/* 获取树选中的节点 */
export function getTreeNode(data) {
  let result = [];

}
export default {
  getAllNode,
  getAllNodeV2,
  runLogin,
  addTab,
  getTab,
  delTab,
  formatDate,
  runAnimation,
  destroyAnimation,
  getTypeOptions,
  getHost,
  getActiveAuth,
  getMenuList,
  getSelectMenuNode,
  getArrByKey,
  getSymbolData,
  formatDateLine,
  updateTreeData,
  updateTreeDataV2,
  connect,
  disConnect,
  initWebSocket,
  WebSocket_W,
  formatMoney,
  unique
}



// WEBPACK FOOTER //
// ./src/utils/common.js